import type { QuestionnaireCardData } from './types';

export function getQuestionnaireAssignmentMeta(card: QuestionnaireCardData) {
  const assignedCount = Number.isFinite(card.assignedClientsCount) ? card.assignedClientsCount : 0;
  const isAssigned = typeof card.assigned === 'boolean' ? card.assigned : assignedCount > 0;

  return {
    isAssigned,
    assignedCount,
  };
}
